
import store from '@/store'
import { router } from '@/router'
import { ElMessage } from 'element-plus'
const ERROR_CODE_TABLE = {
    '10000': codeFunc10000,
    '10007': codeFunc10007,
    '10008': codeFunc10008,
    '10009': codeFunc10009,
    '10010': codeFunc10010,
    '10013': codeFunc10013,
    'Not authenticated':codeFuncAuthenticated,
    '10027': codeFunc10027,
    '10028': codeFunc10028,

}
function codeFunc10000(){
    ElMessage({
        type: 'error',
        message: '用户名或密码错误',
        center: true
      })
}
function codeFunc10007(){
    router.push('/401')
}
function codeFunc10008(){
    router.push('/401/linkDisable')
}
function codeFunc10009(){
    router.push('/401/linkNotTime')
}
function codeFunc10010(){
    router.push('/401')
}
function codeFunc10013(){
    router.push('/401/linkTimeout')
}
function codeFuncAuthenticated(){
    ElMessage({
        type: 'error',
        message: '用户登录信息已过期，请重新登录!',
        center: true
      })
    store.dispatch('user/logout')
}
function codeFunc10027(){
    ElMessage({
        type: 'error',
        message: '登录信息验证失败，请重新登录国家智慧教育督导平台后再进行此操作!',
        center: true
      })
}
function codeFunc10028(){
    ElMessage({
        type: 'error',
        message: '登录信息无效,请重新登录！',
        center: true
      })
}

function makeErrorHandle401(errorCode){
    ERROR_CODE_TABLE[errorCode]()
}

export {makeErrorHandle401}